










































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import tradeBank from '@/const/words/tradeBank';
import LayerPopup from '@/components/LayerPopup.vue';
import { toI18n } from '@/utils/commonUtils';
import { PostMallsRequest, PutOrderconfigsCartRequest, PostProductsConfigurationRequest } from 'supporter';
import { refreshToken } from '@/utils/dataUtils';
@Component({
  components: { LayerPopup },
})
export default class MallAddForm extends Vue {
  // mall
  private mall: any = {
    mallName: '',
    countryCode: 'NONE',
    timeZone: 'NONE',
    serviceCenterPhoneNo: '',
    emailId: '',
    emailDomain: '',
    outboundEmailId: 'noreply',
    outboundEmailDomain: '',
    serviceCenter: {
      outboundEmail: '',
      phoneNo: '',
      email: '',
    },
  };
  private isMallNameErrorShow: boolean = false;
  private emailCopy: boolean = false;
  private isOutEmailDisabled: boolean = false;
  private isPhoneErrShow: boolean = false;
  private isEmailErrShow: boolean = false;
  private isOutEmailErrShow: boolean = false;
  // tradeBankAccountInfo
  private bankList: any[] = tradeBank;
  private tradeBankAccountInfo: any[] = [
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
    {
      bank: '',
      bankAccount: '',
      bankDepositorName: '',
      isErrorShow: false,
      isDisabled: false,
    },
  ];
  // cartConfig
  private storagePeriodList: any[] = [1, 2, 3, 4, 5, 6, 7, 15, 30];
  private storageMaxQuantityList: any[] = [10, 20, 30, 40, 50, 100];
  private cartConfig: any = {
    storagePeriodNoLimit: true,
    storagePeriod: 7,
    storageMaxQuantity: 50,
    cartEquivalentOptionUnitType: 'QUANTITY',
  };
  private isCartConfigUnitTypeDisabled: boolean = false;
  private isStoragePeriodDisabled: boolean = true;
  private isCartPopShow: boolean = false;
  private cartpPopupRequestData: any = {
    id: 'cartPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_CARTPOPUP_TIT',
    width: 570,
  };
  // productConfig
  private productConfig: any = {
    categoryCommissionUsed: true,
    productDetailUrl: '',
    productDetailUrlForMobile: '',
    wmsUsed: false,
    wmsCompany: 'CJINEX',
    // NUMBER
    safetyStockControlPoint: '',
    // NUMBER
    safetyStockRatio: '',
    // NUMBER
    safetyStockCount: '',
  };
  private isProductWmsDisabled: boolean = false;
  private isWmsTypeDisabled: boolean = true;
  private isProductPopShow: boolean = false;
  private isWmsErrShow: boolean = false;
  private isWmsFailShow: boolean = false;
  private isWmsAlertShow: boolean = false;
  private productPopupRequestData: any = {
    id: 'productPopUp',
    hasConfirmBtn: false,
    title: 'MALL_FORM_PRODUCTPOPUP_TIT',
    width: 570,
  };
  private emailCopyMethod(copyDirect: boolean): void {
    if (this.emailCopy) {
      this.isOutEmailDisabled = true;
      this.mall.outboundEmailId = this.mall.emailId;
      this.mall.outboundEmailDomain = this.mall.emailDomain;
    } else {
      if (copyDirect) {
        this.mall.outboundEmailId = '';
        this.mall.outboundEmailDomain = '';
        this.isOutEmailDisabled = false;
      }
    }
  }
  @Watch('emailCopy')
  private emailCopyWatchTriggerByEmailCopy() {
    this.emailCopyMethod(true);
  }
  @Watch('mall.emailId')
  @Watch('mall.emailDomain')
  private emailCopyWatchTriggerByEmailId() {
    this.emailCopyMethod(false);
  }
  @Watch('cartConfig.storagePeriodNoLimit')
  private storagePeriodNoLimitWatch() {
    if (this.cartConfig.storagePeriodNoLimit) {
      this.isStoragePeriodDisabled = true;
    } else {
      this.isStoragePeriodDisabled = false;
    }
  }
  @Watch('productConfig.wmsUsed')
  private wmsUsedWatch() {
    if (this.productConfig.wmsUsed) {
      this.isWmsTypeDisabled = false;
    } else {
      this.isWmsTypeDisabled = true;
    }
  }
  created() {}
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }
  private checkBankAccount(e, index) {
    let val: any = $(e.target).val();
    if (!val) {
      this.tradeBankAccountInfo[index].isErrorShow = false;
      return;
    }
    let reg = /^[0-9]+$/;
    if (!reg.test(val)) {
      this.tradeBankAccountInfo[index].isErrorShow = true;
      this.tradeBankAccountInfo[index].bankAccount = val.replace(/\D/g, '');
      setTimeout(() => {
        this.tradeBankAccountInfo[index].isErrorShow = false;
      }, 200);
    }
  }
  private checkServiceAll(val, name, regType) {
    let phoneReg = /^[0-9\-+\(\)]+$/;
    let emailReg = /^[a-z0-9+.\-_]+$/;
    let domainReg = /^[a-z0-9\-+.]+$/;

    if (name === 'isEmailErrShow') {
      if (regType === 'mail' && !emailReg.test(val)) {
        this[name] = true;
        this.mall.emailId = this.mall.emailId.replace(/[^a-z0-9+.\-_]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      } else if (regType === 'domain' && !domainReg.test(val)) {
        this[name] = true;
        this.mall.emailDomain = this.mall.emailDomain.replace(/[^a-z0-9\-+.]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
    if (name === 'isOutEmailErrShow') {
      if (regType === 'mail' && !emailReg.test(val)) {
        this[name] = true;
        this.mall.outboundEmailId = this.mall.outboundEmailId.replace(/[^a-z0-9+.\-_]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      } else if (regType === 'domain' && !domainReg.test(val)) {
        this[name] = true;
        this.mall.outboundEmailDomain = this.mall.outboundEmailDomain.replace(/[^a-z0-9\-+.]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
    if (name === 'isPhoneErrShow') {
      if (!phoneReg.test(val)) {
        this[name] = true;
        this.mall.serviceCenterPhoneNo = val.replace(/[^0-9\-+\(\)]/g, '');
        setTimeout(() => {
          this[name] = false;
        }, 200);
      }
    }
  }
  private checkWms(e, dataName) {
    let val: any = $(e.target).val();
    let reg = /^[1-9][0-9]+$/;
    if (!val) {
      this.isWmsErrShow = false;
      this.isWmsAlertShow = false;
      this.isWmsFailShow = false;
      return;
    }
    if (!reg.test(val)) {
      this.isWmsErrShow = true;
      this.productConfig[dataName] = val.replace(/[^1-9]+$/g, '');
      setTimeout(() => {
        this.isWmsErrShow = false;
      }, 500);
    }
    if (this.productConfig.safetyStockControlPoint) {
      if (Number(this.productConfig.safetyStockCount) > Number(this.productConfig.safetyStockControlPoint)) {
        if (dataName == 'safetyStockControlPoint') {
          this.isWmsFailShow = true;
          this.isWmsAlertShow = false;
        }
        if (dataName == 'safetyStockCount') {
          this.isWmsAlertShow = true;
          this.isWmsFailShow = false;
        }
      } else {
        this.isWmsFailShow = false;
        this.isWmsAlertShow = false;
      }
    }
  }
  private bankEdit(index) {
    this.tradeBankAccountInfo[index].bank = '';
    this.tradeBankAccountInfo[index].bankAccount = '';
    this.tradeBankAccountInfo[index].bankDepositorName = '';
    this.tradeBankAccountInfo[index].isDisabled = false;
  }
  private beforeAddSaveCheck(): any {
    // 1.쇼핑몰 기본정보 (사용여부 제외)
    if (!this.mall.mallName) {
      alert(this.$t('MALL_FORM_NO_MALLNAME_ALERT'));
      return false;
    }
    if (this.mall.countryCode === 'NONE') {
      alert(this.$t('MALL_FORM_NO_COUNTRY_ALERT'));
      return false;
    }
    if (this.mall.timeZone === 'NONE') {
      alert(this.$t('MALL_FORM_NO_TIMEZONE_ALERT'));
      return false;
    }
    // 2.쇼핑몰 계좌번호
    if (
      !this.tradeBankAccountInfo[0].bank ||
      !this.tradeBankAccountInfo[0].bankAccount ||
      !this.tradeBankAccountInfo[0].bankDepositorName
    ) {
      alert(this.$t('MALL_FORM_NO_FIRST_ACCOUNT_ALERT'));
      return false;
    }
    for (const tb of this.tradeBankAccountInfo) {
      if (tb.bank) {
        if (tb.bankAccount.length === 0 || tb.bankDepositorName.length === 0) {
          alert(this.$t('MALL_FORM_NO_ACCOUNT_BANKACCOUNT_ALERT'));
          return false;
        }
      } else if (tb.bankAccount.length > 0 || tb.bankDepositorName.length > 0) {
        alert(this.$t('MALL_FORM_NO_ACCOUNT_BANK_ALERT'));
        return false;
      }
    }
    // 3.고객센터 전화번호
    this.mall.serviceCenter.phoneNo = this.mall.serviceCenterPhoneNo;
    if (!this.mall.serviceCenter.phoneNo) {
      alert(this.$t('MALL_FORM_NO_SCPHONE_ALERT'));
      return false;
    }
    this.mall.serviceCenter.email = this.mall.emailId + '@' + this.mall.emailDomain;
    this.mall.serviceCenter.outboundEmail = this.mall.outboundEmailId + '@' + this.mall.outboundEmailDomain;
    let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (this.mall.serviceCenter.email.trim() == '@' || !emailReg.test(this.mall.serviceCenter.email)) {
      alert(this.$t('MALL_FORM_NO_SCEMAIL_ALERT'));
      return false;
    }
    if (this.mall.serviceCenter.outboundEmail.trim() == '@' || !emailReg.test(this.mall.serviceCenter.outboundEmail)) {
      alert(this.$t('MALL_FORM_NO_OBEMAIL_ALERT'));
      return false;
    }
    // 4.장바구니 설정 (동일 옵션 표기 단위 이슈)

    // 5.상품 설정 (wms 연동 이슈)
    if (!this.productConfig.productDetailUrl) {
      alert(this.$t('MALL_FORM_NO_PRODUCT_URL_ALERT'));
      return false;
    }
    if (this.productConfig.productDetailUrl.indexOf('{productNo}') < 0) {
      alert(this.$t('MALL_FORM_NO_CORRECT_PRODUCT_URL_ALERT'));
      return false;
    }
    if (
      this.productConfig.productDetailUrlForMobile &&
      this.productConfig.productDetailUrlForMobile.indexOf('{productNo}') < 0
    ) {
      alert(this.$t('MALL_FORM_NO_CORRECT_PRODUCT_MOBILE_URL_ALERT'));
      return false;
    }
    if (this.productConfig.wmsUsed) {
      if (
        !this.productConfig.safetyStockControlPoint ||
        !this.productConfig.safetyStockRatio ||
        !this.productConfig.safetyStockCount ||
        parseInt(this.productConfig.safetyStockControlPoint) < parseInt(this.productConfig.safetyStockCount)
      ) {
        alert(this.$t('MALL_FORM_NO_WMSUSED_CONFIG_ALERT'));
        return false;
      }
    }
    return true;
  }
  private addSave() {
    if (!this.beforeAddSaveCheck()) {
      return;
    }
    if (!confirm(this.$t('MALL_FORM_ADD_MALL_CONFIRM') as string)) {
      return false;
    }
    this.mall.tradeBanks = this.tradeBankAccountInfo;
    let mallObj = { ...this.mall };
    mallObj.tradeBanks = mallObj.tradeBanks.filter(v => {
      if (v.bank) {
        return v;
      }
    });
    mallObj.tradeBanks.forEach(v => {
      delete v.isErrorShow;
      delete v.isDisabled;
    });
    delete mallObj.serviceCenterPhoneNo;
    delete mallObj.emailDomain;
    delete mallObj.emailId;
    delete mallObj.outboundEmailId;
    delete mallObj.outboundEmailDomain;
    let mall: PostMallsRequest = {
      data: mallObj,
    };
    this.$api.postMalls(mall).then(res => {
      let mallNo = Number(res.data.mallNo);

      let cartConfig: PutOrderconfigsCartRequest = {
        params: {
          mallNo,
        },
        data: this.cartConfig,
      };
      const cartConfigAddPromise = new Promise<void>(resolve => {
        this.$api.postOrderconfigsCart(cartConfig).then(() => {
          resolve();
        });
      });

      let productConfig: PostProductsConfigurationRequest = {
        data: this.productConfig,
      };
      productConfig.data.mallNo = mallNo;
      productConfig.data.safetyStockControlPoint = Number(productConfig.data.safetyStockControlPoint);
      productConfig.data.safetyStockRatio = Number(productConfig.data.safetyStockRatio);
      productConfig.data.safetyStockCount = Number(productConfig.data.safetyStockCount);
      const productConfigAddPromise = new Promise<void>(resolve => {
        this.$api.postProductsConfiguration(productConfig).then(() => {
          resolve();
        });
      });

      Promise.all([cartConfigAddPromise, productConfigAddPromise]).then(() => {
        refreshToken().then(() => {
          alert(this.$t('MALL_FORM_ADD_MALL_SUCCESS_ALERT'));
          this.$router.push('/mall/list');
        });
      });
    });
  }
  private cancel() {
    if (!confirm(this.$t('MALL_FORM_ADD_MALL_CANCEL_CONFIRM') as string)) {
      return false;
    }
    this.$router.push('/mall/list');
  }
  private checkMallName(e) {
    let val: any = $(e.target).val();
    if (!val) {
      return;
    }
    let reg = /^[a-zA-Z0-9ㄱ-힣-_ ,.]+$/;
    if (!reg.test(val)) {
      this.isMallNameErrorShow = true;
      this.mall.mallName = val.replace(/[^a-zA-Z0-9ㄱ-힣-_ ,.]/g, '');
      setTimeout(() => {
        this.isMallNameErrorShow = false;
      }, 200);
    }
  }
}
